import TechnologyStackSlider from "./TechnologyStackSlider";

new TechnologyStackSlider().init();
